module.exports = __webpack_public_path__ + "img/logotype_warex_negative@2x.829ea1b.png";